import React from 'react'
import Fragment from '../common/fragment'


function FragmentBD(props) {
  return (
    <Fragment pos="dd" {...props}>
      <p>
Me pregunto si las moscas y las abejas serán las nodrizas balbuceantes del
Muñeco.
      </p>
    </Fragment>
  )
}


export default FragmentBD
